/**
 * Created with IntelliJ IDEA.
 * User: margalitb
 * Date: 23/07/13
 * Time: 5:23 PM
 * Url Item component is used within  the system to show url with contains/exact/advanced dropdown
 *
 * Options:
 * el - mandatory. jQuery element. The element on the page where the component will be created.
 * urlInputPermutation - optional. The url input field permutation.
 * url - optional. The url for the input field.
 * testCollision - optional. testCollision attribute for the dropdown
 * collisionWithinSelector - optional. collisionWithinSelector attribute for the dropdown
 *
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");
    var Translator = require("i18n/translator");
    var template = require("ui/urlComponent/urlComponent.tmpl");
    var Dropdown = require("ui/dropdown/Dropdown");
    var InputField = require("ui/input-field/InputField");
    var BaseModel = require("models/BaseModel");
    var Marionette = require("marionette");
    var _ = require("underscore");
    var URLComponent = {};

    URLComponent = Marionette.Layout.extend({
        template:template,
        initialize:function (options) {
            this.urlPermutation = options.urlInputPermutation || InputField.Permutation.B;
            this.urlTitlePermutation = _.has(options, "urlTitlePermutation") ?  options.urlTitlePermutation : URLComponent.URL_TITLE_PERMUTATION.URL_AND_TITLE;
            this.itemsPlaceholderText = this.getMatchTypeTexts();
            this.model = new Backbone.Model({
                url:options.url || "",
                matchType:options.matchType || URLComponent.matchTypes.CONTAINS
            });
            this.testCollision = _.has(options, "testCollision") ? options.testCollision : null;
            this.collisionWithinSelector = _.has(options, "collisionWithinSelector") ? options.collisionWithinSelector : null;
        },
        ui:{
            matchTypeDropDown:".match-type",
            urlInput:".url-input"
        },

        uiComponents:{
            urlInputField:{
                type:InputField,
                options:{
                    tabindex:2,
                    permutation:"view.urlPermutation",
                    placeholder:"view._getInputPlaceholder",
                    el:"view.ui.urlInput",
                    value: "view._getUrl"
                },
                events:{
                    change:"onUrlChange"
                }
            },
            dropdownMatchType:{
                type:Dropdown,
                options:"_getMatchTypeOptionsObject",
                events:{
                    change:"onDropdownChange"
                }

            }
        },
        _getMatchTypeOptionsObject: function() {
            var options = {
                name:"view.getMatchType",
                selectedOption:"view._getSelectedMatchTypeOption",
                tabindex:1,
                permutation:Dropdown.PERMUTATION.X_SMALL2,
                items:"view._getMatchTypeOptions",
                container:"view.ui.matchTypeDropDown",
                tooltip:"view._getMatchTypeTooltip"
            };
            if (!_.isNull(this.testCollision)) {
                options.testCollision = "view.testCollision";
            }
            if (!_.isNull(this.collisionWithinSelector)) {
                options.collisionWithinSelector = "view.collisionWithinSelector";
            }
            return options;
        },
        getMatchTypeTexts:function () {
            var matchTypes = {};
            _.each(URLComponent.matchTypes, _.bind(function (value, key) {
                matchTypes[value] = {};
                matchTypes[value].name = key;
                matchTypes[value].text =  Translator.translate("LEUIComponents.urlComponent.dropdown." + key + ".text");
                matchTypes[value].placeholder = Translator.translate("LEUIComponents.urlComponent.dropdown." + key + "." + this.urlTitlePermutation + ".placeholder");
                matchTypes[value].tooltip = Translator.translate("LEUIComponents.urlComponent.dropdown." + key + "." + this.urlTitlePermutation + ".toolTip");
            }, this));
            return matchTypes;
        },
        triggerChange:function () {
            this.trigger("change", {matchType:this.model.get("matchType"), url:this.model.get("url")});
        },
        _getUrl:function(){
            return this.model.get("url");
        },
        _getInputPlaceholder:function () {
            return this.itemsPlaceholderText[this.model.get("matchType")].placeholder;
        },
        _getMatchTypeOptions:function () {
            var matchTypeItems = [
                {key: "CONTAINS", value:this.itemsPlaceholderText[URLComponent.matchTypes.CONTAINS].text},
                {key: "EXACT", value:this.itemsPlaceholderText[URLComponent.matchTypes.EXACT].text},
                {key: "ADVANCED", value:this.itemsPlaceholderText[URLComponent.matchTypes.ADVANCED].text}
            ];

            return new Dropdown.Collection(matchTypeItems);
        },
        _getMatchTypeTooltip: function () {
            return this.itemsPlaceholderText[this.model.get("matchType")].tooltip;

        },
        _getSelectedMatchTypeOption:function () {
            return this.itemsPlaceholderText[this.model.get("matchType")].name;
        },
        onUrlChange:function (componentId, eventName, value) {
            this.model.set("url", value.trim());
            this.triggerChange();
        },
        onDropdownChange:function (componentId, eventName, value) {
            this.model.set("matchType", URLComponent.matchTypes[value.selectedKey]);
            this.uiComponents.urlInputField.setPlaceholder(this.itemsPlaceholderText[URLComponent.matchTypes[value.selectedKey]].placeholder);
            this.uiComponents.dropdownMatchType.setTooltip(this.itemsPlaceholderText[URLComponent.matchTypes[value.selectedKey]].tooltip);
            this.triggerChange();
        },

        getURL:function () {
            this.model.get("url");
        },
        setURL:function (url) {
            var trimmedUrl = url.trim();
            this.model.set("url", trimmedUrl);
            this.uiComponents.urlInputField.setValue(trimmedUrl);
        },
        getMatchType:function () {
            this.model.get("matchType");
        },
        setMatchType:function (matchType) {
            this.model.set("matchType", matchType);
            this.uiComponents.dropdownMatchType.setSelection(this.itemsPlaceholderText[matchType].name);
        },

        setError:function (errorObject) {
            this.clearError();

            if (_.has(errorObject, "url") && errorObject.url.isError) {
                this.uiComponents.urlInputField.setError(true, errorObject.url.errorMsg);
            }

            if (_.has(errorObject, "matchType") && errorObject.matchType.isError) {
                this.uiComponents.dropdownMatchType.setError(true, errorObject.matchType.errorMsg);
            }
        },

        clearError: function() {
            this.uiComponents.urlInputField.setError(false);
            this.uiComponents.dropdownMatchType.setError(false);
        }
    });
    URLComponent.matchTypes = {
        CONTAINS:0,
        EXACT:1,
        ADVANCED:2
    };
    URLComponent.URL_TITLE_PERMUTATION = {
        URL_AND_TITLE:"includeTitle",
        URL_ONLY:"urlOnly"
    };

    return URLComponent;
});
